<template>
    <div id="app">
        <header class="header-unauth row" v-if="routeIsPublic()">
            <div class="header-unauth__logo col-lg-3 col-md-3 col-6">
                <div class="site-logo">
                    <img src="https://www.justcompileit.com/videos/cursos-streaming/images/logo.jpg" alt="">
                </div>
            </div>
            <div class="header-unauth__buttons col-lg-9 col-md-9 col-6">
                <router-link to="/login" v-if="pathIs('registro') || pathIs('recuperar') || pathIs('recuperarToken')"><a class="site-btn header-btn">Iniciar sesión</a></router-link>
                <router-link to="/registro" v-if="pathIs('login')"><a class="site-btn header-btn">Regístrate</a></router-link>
            </div>
        </header>
        <div v-else>
            <header class="header-section">
                <div class="ml-4 mr-4">
                    <div class="row">
                        <div class="col-lg col-md d-flex">
                            <div class="nav-switch" @click="sideNav">
                                <font-awesome-icon icon="bars" class="m-auto pointer"/>
                            </div>
                            <div class="site-logo">
                                <img src="https://www.justcompileit.com/videos/cursos-streaming/images/logo.jpg" alt="">
                            </div>
                        </div>
                        <div class="col-lg col-md">
                            <a @click="logout" class="site-btn header-btn d-none d-md-block">Cerrar sesión</a>
                            <nav ref="mainMenu" class="main-menu">
                                <ul>
                                    <!-- <li><router-link to="/">Inicio</router-link></li> -->
                                    <li><router-link to="/">Mis cursos</router-link></li>
                                    <li><a href="https://www.chachiguitar.com/tienda" target="_blank">Tienda</a></li>
                                    <!-- <li><router-link to="/perfil">Mi Perfil</router-link></li> -->
                                    <li><a @click="logout" class="d-md-none pointer">Cerrar sesión</a></li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
        </div>
        <!-- <CourseList :courses="courses"></CourseList> -->
        <router-view :key="$route.fullPath"/>
        <div class="footer">
            <p class="m-0 p-2">
                Copyright &copy; <a href="https://chachiguitar.com/" target="_blank">Chachiguitar</a> developed by <a href="https://justcompileit.com/" target="_blank">Just Compile It</a>
            </p>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '@/config.js'
// import CourseList from '@/components/CourseList.vue'

require('@/assets/css/bootstrap.min.css')
require('@/assets/css/style.css')

export default {
    name: 'app',
    components: {
        // CourseList
    },
    data() {
        return {
            courses: null
        }
    },
    created() {
        console.log(this.$route.meta)
        let token = localStorage.getItem('token')
        if (token) {
            this.$store.commit('setUserToken', token);
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
			axios.get(`${API_URL}/private/user`, config)
				.then(response => {
					if (response.status != 200) {
                        localStorage.removeItem('token');
                        this.$store.commit('setUserToken', null);
                        this.$store.commit('setUserEmail', null);
                        this.$router.push('login');
                    } else {
                        this.$store.commit('setUserEmail', response.data.email);
                    }
				})
				.catch(() => {
					localStorage.removeItem('token');
                    this.$store.commit('setUserToken', null);
                    this.$store.commit('setUserEmail', null);
                    this.$router.push('login');
				});
        }
    },
	methods: {
		logout() {
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.getters.user.token
                }
            }
			axios.post(`${API_URL}/private/security/logout`, [], config)
				.then(response => {
					if (response.status == 200) {
						localStorage.removeItem('token');
                        this.$store.commit('setUserToken', null);
                        this.$store.commit('setUserEmail', null);
                        this.$router.push('login');
					} else {
						console.log(response);
					}
				})
				.catch(err => {
                    console.log(err);
				});
        },
        pathIs(path) {
            return this.$route.name == path;
        },
        routeIsPublic() {
            return this.$route.meta.noAuth
        },
        sideNav() {
            window.$('.main-menu').slideToggle(400);
        }
    }
}
</script>

<style src="@/assets/css/style.css"></style>
<style src="@/assets/css/bootstrap.min.css"></style>

<style lang="scss">
@import "@/variables.scss";
#app {
    font-family: Arial;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    .header-section {
        height: $header-unauth-height;
        padding-top: 30px;
        @media (max-width: 767px) {
            padding-top: 20px;
        }
        .main-menu {
            a:hover {
                color: $main-color;
                text-decoration: none;
            }
        }
    }
    .header-unauth {
        width: 100%;
        height: $header-unauth-height;
        margin: 0;
        position: fixed;
        z-index: 5;
        background-color: white;
        -webkit-box-shadow: 0 3px 5px rgba(57, 63, 72, 0.3);
        -moz-box-shadow: 0 3px 5px rgba(57, 63, 72, 0.3);
        box-shadow: 0 3px 5px rgba(57, 63, 72, 0.3);
        &__buttons {
            margin: auto;
            padding-right: 40px;
        }
        &__logo {
            margin: auto;
        }
    }
    .site-logo {
        img {
            max-height: 54px;
        }
    }
}

.site-btn {
    background-color: $main-color;
    color: white !important;
    &:hover, &:focus {
        background-color: $main-color-dark;
        -webkit-transition: background-color 100ms linear;
        -ms-transition: background-color 100ms linear;
        transition: background-color 100ms linear;
        text-decoration: none !important;
    }
    &:disabled {
        background-color: #ccc;
        cursor: initial;
        &:hover, &:focus {
            background-color: #ccc;
        }
    }
}

@media only screen and (max-width: 767px) {
    .header-btn {
        display: block;
        min-width: 90px;
    }
}

.loader-container {
    display: flex;
    width: 100%;
    .loader {
        position: relative;
        height: 58px;
        width: 58px;
        margin: auto;
        top: auto;
        left: auto;
    }
}

input[type=text]:focus, input[type=email]:focus, input[type=password]:focus, textarea:focus {
    border-bottom: 2px solid $main-color !important;
}

#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.footer {
    border-top: 1px solid #eee;
}
</style>
